module.exports = __webpack_public_path__ + "static/img/SOS1.160745d8.png";